module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hospitals/noimage_s1000x333-1fde65fd444db6cff34bda17cdd118a5.png";